/*
  What each shipping rate actually includes.

  Assembly used to be a product option with its own description next to it.
  It is now a shipping rate, and Shopify gives us only a name and a price, so
  the explanation has to be attached here.

  Matched loosely on the rate name so renaming a rate in the admin does not
  silently blank the description - "Local Delivery & Assembly" and "Inside
  Delivery & Assembly" both land on the assembly text.
*/
(function () {
  function ctxRateNote(name) {
    var n = String(name == null ? '' : name).toLowerCase();

    if (n.indexOf('pick') !== -1) {
      return 'Free. Collect it yourself from our Jarrell, TX warehouse by appointment.';
    }

    /*
      "Local Garage Delivery (Inside When It Fits)" must be tested BEFORE the
      assembly branch below, because its name contains the word "inside".

      Without this it matched the assembly text, so the $150 garage rate and the
      $397 white glove rate showed the IDENTICAL description - two options $250
      apart reading the same, with the cheaper one promising an assembly it does
      not include.

      Wording matches Dillon's current Intuitive Shipping description verbatim,
      9 Aug 2026 - his previous edit there never reached this rate because this
      file is a hardcoded fallback, not a live pull from IS (Shopify's rate
      response only ever carries a name and a price, never IS's own description
      text), so nothing here was "cached" - it just hadn't been updated to match.
      If he edits the IS description again, it has to be copied here by hand too.
    */
    if (n.indexOf('garage') !== -1) {
      return "Our crew delivers to your garage. If your entry allows, we'll bring it inside to your room of choice instead. Cardio machines arrive fully assembled and ready to use; strength equipment is left boxed or crated for you to assemble.";
    }

    /* Assembly is tested before the delivery types on purpose. The assembly
       rates are named after the delivery they upgrade, so "Local Delivery &
       Assembly" contains "local delivery" and would otherwise match that
       first and lose the assembly wording. */
    if (n.indexOf('assembl') !== -1 || n.indexOf('install') !== -1 || n.indexOf('inside') !== -1) {
      return 'We bring it inside, assemble it in the room you choose, and haul the packaging away.';
    }

    /* Checked AFTER the assembly branch so "White Glove Delivery & Assembly" keeps
       the assembly wording. This catches the names that say white glove WITHOUT the
       word assembly - the cart returns "Full Service White Glove Delivery", which
       matched no branch at all and so printed no description beside a $300 rate. */
    if (n.indexOf('glove') !== -1) {
      return 'Delivered inside, set up in the room you choose, and the packaging taken away.';
    }

    if (n.indexOf('truckload') !== -1 || n.indexOf('ftl') !== -1) {
      return 'A dedicated truck for large orders. You unload on site.';
    }

    if (n.indexOf('local') !== -1) {
      return 'Our own crew delivers to your driveway or garage. Setting it up is left to you.';
    }

    if (n.indexOf('curb') !== -1 || n.indexOf('driveway') !== -1 || n.indexOf('freight') !== -1) {
      return 'The carrier leaves the crate at your driveway. Moving it inside and assembling it is left to you.';
    }

    return '';
  }

  window.ctxRateNote = ctxRateNote;
})();